export default __webpack_public_path__ + "static/media/Gunpowder.768f067b.PNG";